import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { PersonOrganization } from '../model/personorganization';
import { environment } from '@src/environments/environment';
import { Projectcomment } from '@src/app/models/comment';
import { Task } from '@src/app/models/task';
import { Projectmember } from '../model/projectmember';

@Injectable({
  providedIn: 'root'
})
export class FooterService {

  personUrl:string = environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/';
  
  constructor(private http:HttpClient) { }

  getPersonOrgList(personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var urlCombo = this.personUrl+personId+'/organization/mylist';

    return this.http.get<PersonOrganization[]>(urlCombo,httpOptions);
  }
  saveComment(comment:Projectcomment){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //POST	/project/{projectId}/comment
    return this.http.post<string>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+comment.projectId+'/comment',JSON.stringify(comment),httpOptions)
  }
  getComments(projectId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    
    //GET	/project/{projectId}/comment/list
    return this.http.get<Projectcomment[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId+'/comment/list',httpOptions)
 
  }
  deleteComment(projectId:string,commentId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId+'/comment/'+commentId,httpOptions)
 
  }
  getTask(taskId:string,projectId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    
    //GET	/project/{projectId}/comment/list
    return this.http.get<Task>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId+'/task/'+taskId.substr(0,36)+'/pit/'+ new Date().toISOString(),httpOptions)
 
  }
  
  getCustomerMembers(projectId:string,customerId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var pit = new Date().toISOString();
    //try cast to Projectmember
    return this.http.get<Projectmember[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId.substring(0,36)+'/user/list/pit/'+pit,httpOptions)

  }
  //Get org
  getOrg(orgId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl+'/organization/'+orgId,httpOptions)
  }

}
